import React from 'react';
import css from './student.scss';
import { getTranslationKey } from '../../../helpers/locale-helpers';
import { LEVEL_LOWERCASE } from '../../../components/report-filters/filter-constants';

const STUDENT_DISCLAIMER = 'Disclaimer Live Maths - Student';

const Q_PER_MIN = 'questionsPerMinute';
const TOTAL_CORRECT = 'totalCorrect';
const ACCURACY = 'accuracy';
const TOP_SCORE = 'topScore';

const generateColHeader = (mainText, subText) => {
    const i18n = window.i18n;
    return (
        <div className={css['col-header']}>
            <span>{i18n._(mainText)}</span>
            {subText && <span>({i18n._(subText)})</span>}
        </div>
    );
};

const STUDENT_TABLE_CONFIG = {
    cols: [
        {
            id: LEVEL_LOWERCASE,
            name: getTranslationKey(LEVEL_LOWERCASE),
            doTranslation: true,
            classes: css.level
        },
        {
            id: Q_PER_MIN,
            headerTransform: () =>
                generateColHeader('Column Header - QMin', 'Column Header - Avg')
        },
        {
            id: TOTAL_CORRECT,
            headerTransform: () =>
                generateColHeader(
                    'Column Header - Correct',
                    'Column Header - Total'
                )
        },
        {
            id: ACCURACY,
            headerTransform: () =>
                generateColHeader(
                    'Column Header - Accuracy',
                    'Column Header - Avg'
                )
        },
        {
            id: TOP_SCORE,
            headerTransform: () =>
                generateColHeader(
                    'Column Header - TopScore',
                    'Column Header - Lifetime'
                )
        }
    ],
    footer: {
        cols: [{ id: LEVEL_LOWERCASE, footerDataId: LEVEL_LOWERCASE }]
    },
    emptyDataMessage: 'Empty - LevelsWithResults'
};

const STUDENT_FOOTER_DATA = 'Footer - MaxLevels';

export { STUDENT_TABLE_CONFIG, STUDENT_FOOTER_DATA, STUDENT_DISCLAIMER };



// WEBPACK FOOTER //
// ./containers/live-maths/student/student-constants.js